import {ApiEndPoint} from "../../network/api_end_point";
import {apiCaller, getToken} from "../../network/network_helper";
import StringUtils from "../../utils/string_utils";

const apiEndPoint = new ApiEndPoint();

export const wareHouseListApiCall = async (query, pageSize, currentPage) => {
    try {
        const token = getToken();
        const params = {};

        if (pageSize) {
            params.page_size = pageSize;
        }

        if (currentPage) {
            params.page = currentPage;
        }

        if (query) {
            params.query = query;
        }

        const response = await apiCaller(
            apiEndPoint.authBaseUrl + apiEndPoint.warehouseUrl,

            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                params: params,
            }
        );
        return response;
    } catch (e) {
        throw e;
    }
};

export const driverDetailsApiCall = async () => {
    try {
        const token = getToken();
        const channelId=localStorage.getItem("channelId");
        const response = await apiCaller(
            `${apiEndPoint.masterUrlWithChannelId(channelId)}drivers`,

            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    status: StringUtils.active.toUpperCase(),
                    source: apiEndPoint.source,
                    page_size:5000,
                },
            }
        );
        return response;
    } catch (e) {
        throw e;
    }
};

export const locationUpdateApiCall = async (locationDetails) => {
    try {
        const token = getToken();
        const response = await apiCaller(
            apiEndPoint.authBaseUrl +
            apiEndPoint.locationUpdateApiUrl +
            `${locationDetails.locationId}/`,
            {
                method: "PATCH",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                data: locationDetails.toJson(),
            }
        );

        return response;
    } catch (e) {
        throw e;
    }
};

export const createDriverLocationMapping = async (locationId, driverUid) => {
    try {
        const token = getToken();

        const response = await apiCaller(
            apiEndPoint.authBaseUrl + apiEndPoint.createDriverLocationMappingApiUrl,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                data: {
                    client_location_id: locationId,
                    driver_uid: driverUid,
                },
            }
        );

        return response;
    } catch (e) {
        throw e;
    }
};
